module.exports = __webpack_public_path__ + "static/media/icon_search_ipt.22954096.svg";